import Toastify from 'toastify-js';

/**
 * Show notice 
 * 
 * @param {string} text                      - Message
 * @param {'default'|'error'|'warning'|'info'|'success'} type - Notice type 
 * @param {Object} options                   - Toastify options
 * @param {string|Element} options.icon     - Icon HTML string or DOM element to display before text
 */
export function notice(text = '', type = 'default', options = {}) {
    if (!text) {
        return;
    }
    
    // Извлекаем icon из options, чтобы не передавать его в Toastify
    const { icon, ...toastifyOptions } = options;
    
    // Иконка по умолчанию для типа 'info' (success)
    const successIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><rect width="20" height="20" rx="6" fill="#063527"/><path d="M14 7L8.68966 13L6 10.2727" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    
    // Определяем, какую иконку использовать
    let iconToUse = icon;
    if (!iconToUse && (type === 'success' || type === 'info')) {
        iconToUse = successIcon;
    }
    
    const wrapper = document.createElement('div');
    wrapper.className = 'toastify-wrapper';
    
    const progressBar = document.createElement('div');
    progressBar.className = 'toastify-progress';
    
    const content = document.createElement('div');
    content.className = 'toastify-content';
    
    // Добавляем иконку, если она указана
    if (iconToUse) {
        const iconWrapper = document.createElement('span');
        iconWrapper.className = 'toastify-icon';
        iconWrapper.setAttribute('aria-hidden', 'true');
        
        // Если иконка - строка (HTML), вставляем как HTML
        if (typeof iconToUse === 'string') {
            iconWrapper.innerHTML = iconToUse;
        } 
        // Если иконка - DOM элемент, клонируем его
        else if (iconToUse instanceof Element) {
            iconWrapper.appendChild(iconToUse.cloneNode(true));
        }
        
        content.appendChild(iconWrapper);
    }
    
    const span = document.createElement('span');
    span.className = 'toastify-text';
    span.innerHTML = text;
    
    content.appendChild(span);
    
    wrapper.appendChild(progressBar);
    wrapper.appendChild(content);
    
    const defaultOptions = {
        duration: 3000,
        node: wrapper,
        className: `toastify--${type}`,
        close: true,
        gravity: "bottom", // `top` or `bottom`
        position: "right", // `left`, `center` or `right`
        stopOnFocus: true, // Prevents dismissing of toast on hover
    };

    Object.assign(defaultOptions, toastifyOptions);
    
    const toast = Toastify(defaultOptions);
    const toastElement = toast.showToast();
    
    // Запускаем анимацию прогресс-бара после небольшой задержки для рендеринга
    const duration = defaultOptions.duration || 2000;
    setTimeout(() => {
        progressBar.style.animationDuration = `${duration}ms`;
        progressBar.classList.add('toastify-progress--animate');
    }, 10);
    
    // Обработка паузы при hover (stopOnFocus)
    if (defaultOptions.stopOnFocus && toastElement) {
        const toastNode = toastElement.toastElement || document.querySelector('.toastify');
        if (toastNode) {
            let animationPaused = false;
            
            toastNode.addEventListener('mouseenter', () => {
                if (!animationPaused) {
                    progressBar.style.animationPlayState = 'paused';
                    animationPaused = true;
                }
            });
            
            toastNode.addEventListener('mouseleave', () => {
                if (animationPaused) {
                    progressBar.style.animationPlayState = 'running';
                    animationPaused = false;
                }
            });
        }
    }
    
    return toast;
}